import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import {Button} from '@deere/fuel-react';

const ConfirmEditAddressDialog = ({ open, onClose, onConfirm, status }) => {
     // Function to format the status string
     const formatStatus = (status) => {
        return status.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    };
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                className: "w-[500px] h-[180]",
            }}
        >
            <DialogTitle><h4>Confirm Edit Address</h4></DialogTitle>
            <DialogContent>
                <h6>The Order is currently <strong>{formatStatus(status)}</strong>, Do you want to edit the address?</h6>
                <h6><strong>NOTE:</strong> Manual Check of Forwarder and Cost are needed.</h6>

            </DialogContent>
            <DialogActions>
                <Button  onClick={onConfirm} variant="primary">
                    Confirm
                </Button>
                <Button onClick={onClose} variant="secondary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmEditAddressDialog;
